import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DialogSearchData } from './models/dialog-search-data';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule],
})
export class SearchComponent {
    /**
     * Champs du formulaire de saisie de commentaire.
     */
    public searchTextFormControl = new UntypedFormControl(null, [Validators.required]);

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<SearchComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogSearchData
    ) {
        this.searchTextFormControl.setValue(data.text);
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Enregistrer'.
     */
    public search(): void {
        this.data.text = this.searchTextFormControl.value;
        this.dialogRef.close(this.data);
    }
}
